import { render, staticRenderFns } from "./Suhorukhov.vue?vue&type=template&id=77d80036"
import script from "./Suhorukhov.vue?vue&type=script&lang=js"
export * from "./Suhorukhov.vue?vue&type=script&lang=js"
import style0 from "./Suhorukhov.vue?vue&type=style&index=0&id=77d80036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports